import './Policy.css';

export default function CancellationRefund() {
  return (
    <div className="policy-page">
      <div className="policy-hero">
        <h1>↩️ Cancellation &amp; Refund Policy</h1>
        <p>Our policy on cancellations, refunds, and subscription plans</p>
      </div>

      <div className="policy-container">

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">📋</div>
            <h2>1. Acceptance of Terms</h2>
          </div>
          <p>
            This Cancellation and Refund Policy (hereinafter referred to as "Policy") applies to all users of JustService24,
            a unit of Onexvora Business Solutions. By subscribing to or using any of our services, you acknowledge that you
            have read, understood, and agree to be bound by this Policy. This Policy is applicable to all subscriptions,
            payments, and services rendered through our mobile application and website.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">❌</div>
            <h2>2. Cancellation Policy</h2>
          </div>

          <p><strong>2.1 Cancellation by User</strong></p>
          <p><strong>No Voluntary Cancellation:</strong></p>
          <p>
            Once a subscription to a business listing or any other service offered by JustService24 is initiated, the user
            cannot voluntarily cancel the subscription. The subscription will remain active for the entire duration of the
            selected period and will automatically terminate upon reaching its expiry date.
          </p>
          <p><strong>Automatic Cancellation Upon Expiry:</strong></p>
          <p>
            Subscriptions are designed to expire automatically at the end of the billing cycle or the selected subscription
            period. Users will be notified of the impending expiry via email or notifications within the platform.
          </p>
          <p><strong>Renewal Options:</strong></p>
          <p>
            Users may choose to renew their subscription manually before the expiry date to avoid interruption of service.
            No partial refunds will be provided for any unused days remaining in the current subscription period if a new
            subscription is purchased before expiry.
          </p>

          <p><strong>2.2 Cancellation by JustService24</strong></p>
          <p><strong>Violation of Terms of Service:</strong></p>
          <p>JustService24 reserves the right to terminate a user's subscription without prior notice if the user is found to violate our Terms of Service, including but not limited to:</p>
          <ul>
            <li>Engaging in fraudulent activities.</li>
            <li>Misusing the platform for illegal activities.</li>
            <li>Providing false or misleading business information.</li>
            <li>Repeated violations of platform guidelines.</li>
          </ul>
          <p><strong>Immediate Effect:</strong></p>
          <p>
            Cancellation of a subscription by JustService24 due to violations will take effect immediately.
            No refund will be provided for any remaining subscription period.
          </p>
          <p><strong>Notification of Cancellation:</strong></p>
          <p>
            Users whose subscriptions are canceled by JustService24 will be notified via the email address associated
            with their account. The notification will include the reason for cancellation and any further actions required.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">💰</div>
            <h2>3. Refund Policy</h2>
          </div>

          <p><strong>3.1 Refunds for Subscription Fees</strong></p>
          <p><strong>Non-Refundable Policy:</strong></p>
          <p>All subscription fees paid to JustService24 are strictly non-refundable. This includes, but is not limited to, cases of:</p>
          <ul>
            <li>Early termination of subscription by the user.</li>
            <li>Non-usage of the service after payment.</li>
            <li>Dissatisfaction with the service provided.</li>
          </ul>
          <p><strong>No Partial Refunds:</strong></p>
          <p>
            JustService24 does not provide partial refunds for any remaining days of an active subscription if the service
            is discontinued or if the user decides not to use the service.
          </p>

          <p><strong>3.2 Refunds for Service Interruption</strong></p>
          <p><strong>Eligibility for Refund:</strong></p>
          <p>
            In the event of a significant and documented service interruption that persists for more than 7 consecutive days,
            users may be eligible for a pro-rated refund. This refund will be calculated based on the number of days the
            service was unavailable in relation to the total subscription period.
          </p>
          <p><strong>Definition of Service Interruption:</strong></p>
          <p>A service interruption is defined as a period during which the user is unable to access the subscribed service due to issues within JustService24's control. This does not include interruptions caused by:</p>
          <ul>
            <li>Scheduled maintenance.</li>
            <li>Internet connectivity issues on the user's end.</li>
            <li>External factors beyond JustService24's control.</li>
          </ul>
          <p><strong>Documentation Requirements:</strong></p>
          <p>To qualify for a refund, users must provide documented evidence of the interruption, including but not limited to:</p>
          <ul>
            <li>Screenshots of error messages.</li>
            <li>Detailed logs of the interruption.</li>
            <li>Correspondence with JustService24's support team.</li>
          </ul>

          <p><strong>3.3 Refunds for Cancellations</strong></p>
          <p><strong>No Refund for User-Initiated Cancellations:</strong></p>
          <p>
            Refunds will not be provided for any user-initiated cancellations of the subscription. Once a subscription fee
            is paid, it is considered final and non-refundable.
          </p>
        </div>

        <div className="policy-section">
          <div className="policy-section-header">
            <div className="policy-section-icon">🔄</div>
            <h2>4. Changes to the Policy</h2>
          </div>
          <p><strong>Right to Modify:</strong></p>
          <p>
            JustService24 reserves the right to modify, amend, or update this Policy at any time without prior notice.
            Any changes made to the Policy will be effective immediately upon being posted on our platform.
          </p>
          <p><strong>User Notification:</strong></p>
          <p>
            Users will be notified of any significant changes to the Policy via email or through notifications on the platform.
            It is the user's responsibility to review the Policy periodically to stay informed of any updates.
          </p>
        </div>

        <div className="policy-contact-box">
          <h3>📬 Contact Us</h3>
          <p>For any questions, concerns, or disputes regarding this Policy, please contact us at:</p>
          <p>📧 Email: <a href="mailto:support@justservice24.com">support@justservice24.com</a></p>
          <p>🌐 Website: <a href="http://www.justservice24.com">www.justservice24.com</a></p>
          <p>🏢 Onexvora Business Solutions, India</p>
          <p>📞 Support: Mon–Sat, 10:00 AM – 6:00 PM</p>
          <p>By using our website and services, you acknowledge and agree to these terms and conditions.</p>
        </div>
      </div>
    </div>
  );
}
